import FeatureSet from '../feature-set';
import SystemRoles from '../system-roles';

const PermissionManagement = () => {
  return (
    <>
      <div className='mb-8'>
        <FeatureSet hasId='feature-set' />
      </div>
      <SystemRoles hasId='roles' />
    </>
  );
};

export default PermissionManagement;
